import {FC, memo} from "react";
import {BuilderGroupProps} from "./BuilderGroup-types";
import {Description, Head, Root, Title} from "./BuilderGroup-styles";
import {DescriptionSkeleton} from "./BuilderGroup-skeleton";

const BuilderGroup: FC<BuilderGroupProps> = memo((props) => {
    const {title, description, isLoading, isVisibleOnMobile} = props;

    return (
        <Root $isVisibleOnMobile={isVisibleOnMobile || false}>
            <Head>
                <Title>{title}</Title>

                <Description>
                    {
                        isLoading
                            ? <DescriptionSkeleton/>
                            : description
                    }
                </Description>
            </Head>
        </Root>
    );
});

export default BuilderGroup;
